import {
  FOC_TOUR_LABEL_PLN_DEMOB,
  FOC_TOUR_LABEL_PLN_DOCS,
  FOC_TOUR_LABEL_PLN_PSC,
  FOC_TOUR_LABEL_PLN_RESOURCE,
  FOC_TOUR_LABEL_PLN_SITL,
} from '../focTourLabels';
import {
  FOC_PLN_DEMOB_TOUR_HREF,
  FOC_PLN_DEMOB_TOUR_PARAM,
  FOC_PLN_DEMOB_TOUR_STEPS,
} from './focPlnDemobTourSteps';
import {
  FOC_PLN_DOCS_TOUR_HREF,
  FOC_PLN_DOCS_TOUR_PARAM,
  FOC_PLN_DOCS_TOUR_STEPS,
} from './focPlnDocsTourSteps';
import {
  FOC_PLN_PSC_TOUR_HREF,
  FOC_PLN_PSC_TOUR_PARAM,
  FOC_PLN_PSC_TOUR_STEPS,
} from './focPlnPscTourSteps';
import {
  FOC_PLN_RESOURCE_TOUR_HREF,
  FOC_PLN_RESOURCE_TOUR_PARAM,
  FOC_PLN_RESOURCE_TOUR_STEPS,
} from './focPlnResourceTourSteps';
import {
  FOC_PLN_SITL_TOUR_HREF,
  FOC_PLN_SITL_TOUR_PARAM,
  FOC_PLN_SITL_TOUR_STEPS,
} from './focPlnSitlTourSteps';
import type { FocPlnTourStepDef } from './focPlnTourTypes';

export {
  FOC_PLN_PSC_TOUR_HREF,
  FOC_PLN_SITL_TOUR_HREF,
  FOC_PLN_RESOURCE_TOUR_HREF,
  FOC_PLN_DOCS_TOUR_HREF,
  FOC_PLN_DEMOB_TOUR_HREF,
};

export type FocPlnTourKey =
  | 'psc'
  | 'sitl'
  | 'resource'
  | 'docs'
  | 'demob';

export type FocPlnTourEntry = {
  key: FocPlnTourKey;
  param: string;
  seatSlug: string;
  hubHref: string;
  label: string;
  covers: readonly string[];
  steps: readonly FocPlnTourStepDef[];
  rootTour: string;
};

export const FOC_PLN_TOUR_ENTRIES: readonly FocPlnTourEntry[] = [
  {
    key: 'psc',
    param: FOC_PLN_PSC_TOUR_PARAM,
    seatSlug: 'planning-section-chief',
    hubHref: FOC_PLN_PSC_TOUR_HREF,
    label: FOC_TOUR_LABEL_PLN_PSC,
    covers: ['15.1'],
    steps: FOC_PLN_PSC_TOUR_STEPS,
    rootTour: 'position-workspace-root',
  },
  {
    key: 'sitl',
    param: FOC_PLN_SITL_TOUR_PARAM,
    seatSlug: 'situation-unit-leader',
    hubHref: FOC_PLN_SITL_TOUR_HREF,
    label: FOC_TOUR_LABEL_PLN_SITL,
    covers: ['15.2'],
    steps: FOC_PLN_SITL_TOUR_STEPS,
    rootTour: 'sitl-cop-workspace',
  },
  {
    key: 'resource',
    param: FOC_PLN_RESOURCE_TOUR_PARAM,
    seatSlug: 'resource-unit-leader',
    hubHref: FOC_PLN_RESOURCE_TOUR_HREF,
    label: FOC_TOUR_LABEL_PLN_RESOURCE,
    covers: ['15.3'],
    steps: FOC_PLN_RESOURCE_TOUR_STEPS,
    rootTour: 'pln-resource-workspace',
  },
  {
    key: 'docs',
    param: FOC_PLN_DOCS_TOUR_PARAM,
    seatSlug: 'documentation-unit-leader',
    hubHref: FOC_PLN_DOCS_TOUR_HREF,
    label: FOC_TOUR_LABEL_PLN_DOCS,
    covers: ['15.4'],
    steps: FOC_PLN_DOCS_TOUR_STEPS,
    rootTour: 'pln-docs-workspace',
  },
  {
    key: 'demob',
    param: FOC_PLN_DEMOB_TOUR_PARAM,
    seatSlug: 'demobilization-unit-leader',
    hubHref: FOC_PLN_DEMOB_TOUR_HREF,
    label: FOC_TOUR_LABEL_PLN_DEMOB,
    covers: ['15.5'],
    steps: FOC_PLN_DEMOB_TOUR_STEPS,
    rootTour: 'demob-workspace',
  },
];

/** data-tour root for a seat when no SITL chrome overrides it. */
export function focPlnWorkspaceTourRoot(seatSlug: string | undefined): string | null {
  const entry = FOC_PLN_TOUR_ENTRIES.find((e) => e.seatSlug === seatSlug);
  return entry?.rootTour ?? null;
}

export function focPlnTourSeatHref(
  incidentId: string,
  entry: Pick<FocPlnTourEntry, 'seatSlug' | 'param'>
): string {
  return `/iap/${incidentId}/seat/${entry.seatSlug}?${entry.param}=1`;
}

export function findFocPlnTourEntryByParam(
  searchParams: URLSearchParams
): FocPlnTourEntry | null {
  for (const entry of FOC_PLN_TOUR_ENTRIES) {
    if (searchParams.get(entry.param) === '1') return entry;
  }
  return null;
}

export function focPlnTourNavVisible(enabled: boolean): boolean {
  return enabled;
}
